import { Button } from "@light-technology/components";
import { LogOut01, Mail01 } from "@untitledui/icons";
import { useNavigate } from "react-router";
import { api } from "../../state/api";
import { PARTNER_SUCCESS_EMAIL } from "../../utilities/constants";
import { useDocumentTitle } from "../../utilities/useDocumentTitle";

export const NoOrgPage = () => {
  useDocumentTitle("No organization");

  const [logout] = api.useLogoutMutation();
  const navigate = useNavigate();

  return (
    <div className="flex size-full flex-col justify-center text-center">
      <div className="mb-2xl text-lg font-semibold">
        We couldn't find your team
      </div>
      <div className="mb-3xl text-tertiary">
        It doesn't look like you've been added to any teams. Please ask your
        team admin for an invite or reach out to us for help.
      </div>
      <div className="flex flex-col gap-2">
        <Button
          color="secondary"
          size="md"
          iconLeading={Mail01}
          href={`mailto:${PARTNER_SUCCESS_EMAIL}`}
          target="_blank"
        >
          Email us
        </Button>
        <Button
          onClick={() =>
            logout(null).then(() => {
              navigate("/login");
            })
          }
          iconLeading={LogOut01}
        >
          Log out
        </Button>
      </div>
    </div>
  );
};
